import apiRequestService from '@/commonProject/service/apiRequestService';

export default class signinUseridRepository {
    /**
     * ユーザーID通知APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async getUserIdsApi(API_URL, requestBody) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrids', requestBody, null);
        return result;
    }
}
